import Lenis from 'lenis';
import { gsap, ScrollTrigger } from './gsap-config';
import 'lenis/dist/lenis.css';

let activeLenis: Lenis | null = null;

/** One native-window scroller, driven by the same clock as the GSAP timelines. */
export function mountSmoothScroll() {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let disposeInstance: (() => void) | undefined;
  const configure = () => {
    disposeInstance?.();
    disposeInstance = undefined;
    if (preference.matches) return;

    const lenis = new Lenis({
      autoRaf: false,
      lerp: 0.1,
      smoothWheel: true,
      syncTouch: false,
      anchors: { offset: -80 },
    });
    activeLenis = lenis;
    const tick = (seconds: number) => lenis.raf(seconds * 1000);
    const resize = () => lenis.resize();
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.lagSmoothing(0);
    gsap.ticker.add(tick);
    ScrollTrigger.addEventListener('refresh', resize);
    disposeInstance = () => {
      gsap.ticker.remove(tick);
      ScrollTrigger.removeEventListener('refresh', resize);
      lenis.off('scroll', ScrollTrigger.update);
      lenis.destroy();
      if (activeLenis === lenis) activeLenis = null;
    };
  };
  configure();
  preference.addEventListener('change', configure);
  return () => {
    preference.removeEventListener('change', configure);
    disposeInstance?.();
  };
}

export function scrollToTarget(target: HTMLElement | number, { offset = 0, immediate = false }: { offset?: number; immediate?: boolean } = {}) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (activeLenis) {
    activeLenis.resize();
    activeLenis.scrollTo(target, { offset, immediate: immediate || reduced, force: true });
  } else {
    const top = typeof target === 'number' ? target : target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: Math.max(0, top + offset), behavior: immediate || reduced ? 'auto' : 'smooth' });
  }
}
